import { Link } from "react-router-dom";
import SEO from "./SEO";

function NotFound() {
  return (
    <div style={{
      minHeight: "70vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: "40px 24px",
      fontFamily: "inherit",
    }}>
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <div style={{
        fontSize: "7rem",
        fontWeight: 900,
        background: "linear-gradient(135deg, #14c9b2, #7c5cbf)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        lineHeight: 1,
        marginBottom: 16,
      }}>
        404
      </div>
      <h1 style={{ fontSize: "1.6rem", fontWeight: 700, marginBottom: 12 }}>
        Page Not Found
      </h1>
      <p style={{ color: "#64748b", maxWidth: 400, marginBottom: 32, lineHeight: 1.7 }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        style={{
          padding: "12px 28px",
          borderRadius: 10,
          background: "linear-gradient(135deg, #14c9b2, #7c5cbf)",
          color: "#fff",
          fontWeight: 700,
          textDecoration: "none",
          fontSize: "0.95rem",
        }}
      >
        ← Back to Home
      </Link>
    </div>
  );
}

export default NotFound;
